import { render, staticRenderFns } from "./AddCategoria.vue?vue&type=template&id=dc2933b4&"
import script from "./AddCategoria.vue?vue&type=script&lang=js&"
export * from "./AddCategoria.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports